import { fromJS } from 'immutable'

export const advisingState = fromJS({
  id: 0,
  student_id: 0,
  student_id_code: '',
  student_name: '',
  level: '',
  is_open: false,
  semcamp_course_id: 0,
  course_code: '',
  course_name: '',
  curriculum_id: 0,
  curriculum_code: '',
  curriculum_name: '',
  payment_scheme_id: 0,
  paymentscheme_code: '',
  paymentscheme_name: '',
  scholarship_id: 0,
  scholarship_code: '',
  scholarship_name: '',
})

const initialState = fromJS({
  searchResults: [],
  searching: false,
  pending: false,
})

export default function advising(state = initialState, action) {
  switch (action.type) {
    case 'ADV_Q_REQ':
      return state.set('searching', true)

    case 'ADV_REQ':
      return state.set('pending', true)

    case 'ADV_Q_SUCC':
      return state
        .set('searching', false)
        .set('searchResults', fromJS(action.payload || []))

    case 'ADV_GET_SUCC':
    case 'ADV_SAVE_SUCC':
      return state.set('pending', false)

    case 'NOTIF_FAIL':
      return state
        .set('searching', false)
        .set('pending', false)

    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/containers/Advising/reducer.js